var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73473 9.6323C5.73473 7.8733 6.39482 6.18635 7.56979 4.94255C8.74475 3.69876 10.3383 3 12 3C13.6617 3 15.2552 3.69876 16.4302 4.94255C17.6052 6.18635 18.2653 7.8733 18.2653 9.6323V13.1986L19.896 16.6512C19.9711 16.8101 20.0065 16.9867 19.999 17.1641C19.9915 17.3416 19.9412 17.5141 19.8529 17.6653C19.7647 17.8164 19.6414 17.9412 19.4948 18.0277C19.3482 18.1142 19.1832 18.1596 19.0153 18.1595H15.4674C15.2683 18.9727 14.8198 19.6928 14.1922 20.207C13.5646 20.7211 12.7935 21 12 21C11.2065 21 10.4354 20.7211 9.80782 20.207C9.18025 19.6928 8.73171 18.9727 8.53262 18.1595H4.98469C4.81685 18.1596 4.65179 18.1142 4.50519 18.0277C4.35858 17.9412 4.23531 17.8164 4.14706 17.6653C4.05882 17.5141 4.00854 17.3416 4.00099 17.1641C3.99345 16.9867 4.0289 16.8101 4.10397 16.6512L5.73473 13.1986V9.6323ZM10.4498 18.1595C10.6069 18.4476 10.8329 18.6868 11.105 18.8531C11.3771 19.0194 11.6858 19.1069 12 19.1069C12.3142 19.1069 12.6229 19.0194 12.895 18.8531C13.1671 18.6868 13.3931 18.4476 13.5502 18.1595H10.4498ZM12 4.89494C10.8131 4.89494 9.67482 5.39405 8.83556 6.28248C7.9963 7.17091 7.52481 8.37587 7.52481 9.6323V13.1986C7.52479 13.4926 7.46013 13.7826 7.33595 14.0456L6.28876 16.2646H17.7121L16.6649 14.0456C16.5405 13.7827 16.4755 13.4927 16.4752 13.1986V9.6323C16.4752 8.37587 16.0037 7.17091 15.1644 6.28248C14.3252 5.39405 13.1869 4.89494 12 4.89494Z",
    fill: "#475569",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.5b5983c1262dfda22a75d11478c0577f.svg";
export { ForwardRef as ReactComponent };